export const isEmbeddedMobileAppRoute = (pathname: string): boolean =>
  /^\/[^/]+\/embedded-mobile-app(?:\/|$)/.test(pathname)
